import useAuth from "./useAuth"

// This hook runs in the 'strict' mode that is the user has to have the set of permission regardless of whether is an admin or not
function useAuthorizationStrict(required: string[], any: boolean = false) {
  const user = useAuth()
  const permissions = user?.permissions
  const findPermission = (pr: any) => permissions?.find(p => p?.match(pr))
  return user.user?.isSuperadmin
    ? true
    : any
    ? required.some(findPermission)
    : required.every(findPermission)
}

// This hook can only validate a single permission (as it is the most common use case) but it results in faster performance
// use this when the resource is only authorized via a single permission (this runs in the strict mode too)

export function useAuthorizationSimple(permission: string) {
  const { user, permissions } = useAuth()
  return user?.isSuperadmin
    ? true
    : permissions?.find(p => p?.includes(permission.toLowerCase()))
}
export default useAuthorizationStrict
